import styled from 'styled-components';

const FormContainer = styled.div`
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    margin-bottom: 20px;
`

const Input = styled.input`
    width: 220px;
    height: 2em;
    border-radius: 5px;
    border: none;
    padding: 5px 10px;
    margin: 7px 0;

    font-family: IdealSans;

    background-color: rgba(255, 255, 255, 0.9)
`

const Submit = styled.div`
    width: 220px;
    height: 2em;
    border-radius: 5px;
    border: none;
    padding: 5px 10px;
    margin: 7px 0;

    display: flex;
    align-items: center;
    justify-content: center;

    background-color: #470A68;
    color: white;
`

export {
    FormContainer,
    Input,
    Submit
}